export const COMPONENT_NAMES = {
  BREEZE_INTELLIGENCE_WITH_OVERAGES_TILE: {
    TOOLTIP: 'BreezeIntelligenceWithOveragesTileTooltip'
  },
  HUBSPOT_CREDITS_WITH_OVERAGES_TILE: {
    MAIN: 'HubSpotCreditsWithOveragesTile',
    TOOLTIP: 'HubSpotCreditsWithOveragesTileTooltip',
    CHART: 'HubSpotCreditsWithOveragesChart',
    CREDIT_USAGE_WELL_ITEM: 'CreditUsageWellItem'
  },
  CREDIT_PLAN_COMPARATOR: {
    MAIN: 'CreditPlanComparator',
    TALK_TO_SALES: 'CreditPlanComparatorTalkToSales',
    SERVICE_SELECTOR: {
      MAIN: 'CreditPlanComparatorServiceSelector',
      SERVICES: {
        MARKETING: 'CreditPlanComparatorServiceSelectorMarketing',
        SALES: 'CreditPlanComparatorServiceSelectorSales',
        SERVICE: 'CreditPlanComparatorServiceSelectorService',
        CONTENT: 'CreditPlanComparatorServiceSelectorContent',
        DATA: 'CreditPlanComparatorServiceSelectorData'
      }
    }
  },
  CREDIT_ICON_WITH_POPOVER: 'CreditIconWithPopover',
  CREDIT_ICON_WITH_TOOLTIP: 'CreditIconWithTooltip',
  COMPARE_CREDIT_PLANS_BANNER: {
    MAIN: 'CompareCreditPlansBanner',
    CTA: 'CompareCreditPlansBannerCTA'
  },
  NOTIFICATION_BANNER: 'NotificationBanner',
  CREDITS_CALCULATOR: {
    MAIN: 'CreditsCalculator',
    BUY_NOW: 'CreditsCalculatorBuyNow',
    TALK_TO_SALES: 'CreditsCalculatorTalkToSales'
  },
  LEARN_ABOUT_CREDITS_SECTION: 'LearnAboutCreditsSection',
  HUBSPOT_CREDITS_CARD: {
    MAIN: 'HubSpotCreditsCard',
    LEARN_MORE_LINK: 'HubSpotCreditsCardLearnMoreLink',
    MANAGE_USER_PERMISSIONS_LINK: 'HubSpotCreditsCardManageUserPermissionsLink'
  },
  PERCENT_CREDITS_USED_WIDGET: 'PercentCreditsUsedWidget',
  CREDIT_STATUS_BANNER: {
    MAIN: 'CreditStatusBanner',
    CREDITS_REMAINING: 'CreditStatusBannerCreditsRemaining',
    FEATURE_USAGE: 'CreditStatusBannerFeatureUsage'
  },
  CREDIT_BALANCE_TEXT: {
    MAIN: 'CreditBalanceText',
    TOOLTIP: 'CreditBalanceTextTooltip'
  },
  CREDIT_BALANCE_CONTENT: {
    MAIN: 'CreditBalanceContent',
    CTA: 'CreditBalanceContentCTA',
    CANCEL: 'CreditBalanceContentCancel'
  },
  CREDIT_BALANCE_POPOVER: 'CreditBalancePopover',
  CREDITS_PER_ACTION_INFO_BOX: 'CreditsPerActionInfoBox',
  CREDIT_BALANCE_INFO_BOX: 'CreditBalanceInfoBox',
  ESTIMATED_CREDITS_INFO_BOX: 'EstimatedCreditsInfoBox',
  CURRENT_USAGE: {
    CONTAINER: {
      MAIN: 'CurrentUsageContainer',
      TOOLTIP: 'CurrentUsageContainerTooltip',
      REFRESH_BUTTON: 'CurrentUsageContainerRefreshButton'
    },
    CHART: 'CurrentUsageChart'
  },
  CURRENT_USAGE_SUMMARY: {
    CONTAINER: 'CurrentUsageSummaryContainer',
    WELL_ITEM: 'CurrentUsageSummaryWellItem'
  },
  HISTORICAL_USAGE: {
    CONTAINER: {
      MAIN: 'HistoricalUsageContainer',
      TIME_FRAME_PICKER: 'HistoricalUsageContainerTimeFramePicker'
    },
    CHART: 'HistoricalUsageChart'
  },
  USAGE_LOG: {
    CONTAINER: 'UsageLogContainer',
    TABLE: 'UsageLogTable',
    DATE_RANGE_PICKER: 'UsageLogDateRangePicker'
  },
  MANAGE_CREDIT_USAGE: {
    CONTAINER: 'ManageCreditUsageContainer',
    TOOLTIP: 'ManageCreditUsageContainerTooltip',
    CARD: {
      MAIN: 'ManageCreditUsageCard',
      BREEZE_INTELLIGENCE: {
        MAIN: 'ManageCreditUsageCardBreezeIntelligence',
        EXTERNAL_LINK: 'ManageCreditsageCardBreezeIntelligenceExternalLink'
      },
      BREEZE_AGENTS: {
        MAIN: 'ManageCreditUsageCardBreezeAgents',
        EXTERNAL_LINK: 'ManageCreditUsageCardBreezeAgentsExternalLink'
      },
      BREEZE_AUTOMATION: {
        MAIN: 'ManageCreditUsageCardBreezeAutomation',
        EXTERNAL_LINK: 'ManageCreditUsageCardBreezeAutomationExternalLink'
      },
      BUYER_INTENT: {
        MAIN: 'ManageCreditUsageCardBuyerIntent',
        EXTERNAL_LINK: 'ManageCreditUsageCardBuyerIntentExternalLink'
      },
      DATA_STUDIO: {
        MAIN: 'ManageCreditUsageCardDataStudio',
        EXTERNAL_LINK: 'ManageCreditUsageCardDataStudioExternalLink'
      }
    }
  },
  MANAGE_FEATURE_USAGE_TABLE: 'ManageFeatureUsageTable',
  YOUR_CREDITS_CARD: {
    MAIN: 'YourCreditsCard',
    TOOLTIP: 'YourCreditsCardTooltip',
    ADD_CREDITS_LINK: 'YourCreditsCardAddCreditsLink',
    MANAGE_CREDIT_SETTINGS: 'YourCreditsCardManageCreditSettings'
  },
  PAY_AS_YOU_GO_CARD: {
    MAIN: 'PayAsYouGoCard',
    EDIT_MODAL: 'PayAsYouGoEditModal'
  },
  FEATURE_PAUSED_POPOVER: {
    MAIN: 'FeaturePausedPopover',
    CTA: 'FeaturePausedPopoverCTA'
  },
  USES_CREDITS_LABEL: {
    MAIN: 'UsesCreditsLabel',
    POPOVER: 'UsesCreditsPopover'
  },
  CREDIT_FOOTER_ALERT: 'CreditFooterAlert',
  CREDIT_FOOTER: 'CreditFooter',
  CREDITS_CTA: 'CreditsCTA',
  CREDIT_BILLING_WIZARD: {
    OVERAGE_SETTING_SELECTION: 'CreditBillingWizardOverageSettingSelection',
    CREDIT_SPEND_LIMIT_SELECTION: 'CreditBillingWizardCreditSpendLimitSelection'
  },
  BETA: {
    BADGE: 'BetaBadge',
    ALERT: {
      DEPRECATED: 'BetaAlert',
      NOT_MONETIZED: 'BetaAlertNotMonetized',
      DELAYED_MONETIZATION: 'BetaAlertDelayedMonetization'
    },
    ICON: {
      NOT_MONETIZED: 'BetaIconNotMonetized',
      DELAYED_MONETIZATION: 'BetaIconDelayedMonetization'
    }
  }
};
export const WELL_ITEM_TYPES = {
  SUBSCRIPTION_CREDITS_USED: 'SubscriptionCreditsUsed',
  OVERAGE_CREDITS_USED: 'OverageCreditsUsed',
  CURRENT_OVERAGE_COSTS: 'CurrentOverageCosts'
};